<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="jumbotron text-center" style="background-color: #fff">
                    <img  src="../assets/img/logo_IASO.png" alt="Iaso-digital" width="15%" style="margin-bottom:15px; margin-top:5px;">
                    <p>Bienvenue sur la plateforme d'enregistrement des voix de personnages de Iaso Digital !</p>
                    <p style="font-size:16px">Cette plateforme web permet d'afficher les textes des personnages (avatars 3D), qui vous ont été attribués, et que vous devez jouer, et vous permet de vous enregistrer en ligne.</p>
                    <p style="margin-bottom:0px;font-size:16px; " >Iaso Digital récupère, alors, automatiquement les fichiers des voix enregistrées et vous n'avez plus rien à faire !</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-login col-md-offset-4 col-md-4">
                <div @keyup.enter="login()" v-if="!forgottenPassword">
                    <h4>Bienvenue</h4>
                    <input type="text" v-model="username" class="form-control input-sm chat-input" placeholder="Adresse E-mail" />
                    <br>
                    <input type="password" v-model="password" class="form-control input-sm chat-input" placeholder="Mot de passe" />
                    <br>
                    <div class="wrapper">
                        <span class="group-btn">
                            <button :disabled="loginDisabled || !username.length" @click="login()" class="btn btn-primary btn-md">Login</button>
                        </span>
                        <br>
                        <br>
                        <a target="_self" style="text-align:center;cursor:pointer" @click="forgottenPassword = !forgottenPassword">
                            Mot de passe oublié ?
                        </a>
                    </div>
                    <div class="text-center" style="color:red;margin-top:2%;" v-if="badCredentials">
                        La combinaison identifiant/mot de passe rentrée est incorrecte.
                    </div>
                    <div class="text-center" style="color:red;margin-top:2%;" v-if="accessDenied">
                        Vous n'avez plus accès à la ressource demandée<br>
                        Essayez de vous reconnecter.
                    </div>
                </div>
                <div @keyup.enter="forgotPassword()" v-else>
                    <h4>Mot de passse oublié ?</h4>
                    <input v-if="forgotPasswordState != 1" type="text" v-model="username" class="form-control input-sm chat-input" placeholder="E-mail"/>
                    <br>
                    <div class="wrapper" v-if="forgotPasswordState != 1">
                        <button :disabled="!username.length" @click="forgotPassword()" class="btn btn-primary">Valider</button>
                        <button @click="forgottenPassword = false" class="btn btn-danger">Retour</button>
                    </div>
                    <div class="text-center" style="margin-top:2%;" v-if="forgotPasswordState == 1">
                        Un message vous a été envoyé à l'adresse fournie. Vous allez être redirigé vers la page de connexion dans quelques secondes.
                    </div>
                    <div class="text-center" style="color:red;margin-top:2%;" v-if="forgotPasswordState == 2">
                        Votre demande n'a pas pu aboutir. Veuillez réessayer plus tard.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    computed: {
        accessDenied:  function() {
            return this.$store.state.accessDenied;
        },
        badCredentials:  function() {
            return this.$store.state.badCredentials;
        }
    },
    methods: {
        login() {
            let successCallback = (data) => {
                this.$store.commit('TOKEN_UPDATED', {newToken: data.token, newRefreshToken: data.refresh_token});
                this.$store.commit('CURRENT_USER_ROLE', data.role);
                switch (data.role){
                    case 'ADMIN':
                    case 'REAL':
                        this.$router.push({name: 'ThemeList'});
                        break;
                    case 'USER':
                        this.$router.push({name: 'UserPersonList', params: {userId: data.userId}});
                        break;
                }
            };

            this.$store.dispatch('userLogin', {
                username: this.username,
                password: this.password,
                callbacks: {
                    success: successCallback
                }
            });
        },
        forgotPassword()    {
            let successCallback = (data) => {
                this.forgotPasswordState = 1;
                let self = this;
                setTimeout(function()   {
                    self.forgottenPassword = false;
                    self.forgotPasswordState = 0;
                }, 5000);
            };

            let errorCallback = (data) => {
                this.forgotPasswordState = 2;
            };

            this.$store.dispatch('userForgotPassword', {
                username: this.username,
                callbacks: {
                    success: successCallback,
                    error: errorCallback
                }
            });
        }
    },
    data: function()  {
        return {
            username: "",
            password: "",
            forgottenPassword: false,
            forgotPasswordState: 0,
            loginDisabled: true
        };
    },
    created: function() {
        this.username = this.$store.state.user.currentUser.email ? this.$store.state.user.currentUser.email : "";
    },
    beforeMount: function() {
        let self = this;
        this.$router.onReady(function() {
            self.loginDisabled = false;
        });
    }
};
</script>

<style scoped>
.login {
    width: 100%;
    height: 100%;

    position: absolute;
    top: 50%;
    bottom: 0;
    left: 0;
    right: 0;

    margin: auto;
}

@import url(https://fonts.googleapis.com/css?family=Roboto:400);
body {
    background-color:#fff;
    -webkit-font-smoothing: antialiased;
    font: normal 14px Roboto,arial,sans-serif;
}

.form-login {
    background-color: #EDEDED;
    padding-top: 10px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 15px;
    border-color:#d2d2d2;
    border-width: 5px;
    box-shadow:0 1px 0 #cfcfcf;
}

h4 {
    border:0 solid #fff;
    border-bottom-width:1px;
    padding-bottom:10px;
    text-align: center;
}

.form-control {
    border-radius: 10px;
}

.wrapper {
    text-align: center;
}


</style>
